import { render, staticRenderFns } from "./AboutPageParagraphComponent.vue?vue&type=template&id=3a61a9c2&scoped=true&"
import script from "./AboutPageParagraphComponent.vue?vue&type=script&lang=ts&"
export * from "./AboutPageParagraphComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a61a9c2",
  null
  
)

export default component.exports